import { motion } from "framer-motion";
import { FiBriefcase } from "react-icons/fi";

const experiences = [
    {
        company: "Vruksh Ecosystem Pvt. Ltd.",
        role: "GenAI Backend Developer Intern",
        duration: "July 2024 – Dec 2024",
        location: "Remote",
        responsibilities: [
            "Integrated multiple GenAI models and automated AI agent workflows, enhancing efficiency.",
            "Developed a logging platform for monitoring AI models.",
        ],
        techStack: ["React", "Tailwind CSS", "REST API", "LLMs"],
    },
    {
        company: "Codelintech Pvt. Ltd.",
        role: "Software Developer Intern",
        duration: "March 2025 – May 2025",
        location: "Remote",
        responsibilities: [
            "Contributed to backend development using Go, focusing on scalable and clean architecture.",
            "Created and tested RESTful APIs for smooth frontend integration.",
            "Collaborated with senior developers through code reviews to improve code quality.",
        ],
        techStack: ["Go", "SQL", "REST", "Swagger", "Docker"],
    },
];

const ExperienceSection = () => {
    return (
        <section className="py-14 px-4 sm:px-6 lg:px-8 ">
            <div className="max-w-4xl mx-auto">
                <motion.div
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.7 }}
                    viewport={{ once: true }}
                    className="pb-10"
                >
                    <h2 className="text-4xl font-bold text-white border-b-4 border-gray-500 inline-block">
                        Experience
                    </h2>
                </motion.div>

                {experiences.map((exp, index) => (
                    <motion.div
                        key={index}
                        initial={{ opacity: 1, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: index * 0.1 }}
                        viewport={{ once: true }}
                        className="bg-[#1e1e20] backdrop-blur-md border border-white/10 rounded-xl p-6 mb-8 shadow-md hover:shadow-lg transition duration-300 group"
                    >
                        <div className="md:flex md:flex-row md:justify-between">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="p-2 bg-indigo-600/20 rounded-full">
                                    <FiBriefcase className="text-indigo-400 w-5 h-5" />
                                </div>
                                <div>
                                    <h3 className="text-lg sm:text-xl font-bold text-white">
                                        {exp.company}
                                    </h3>
                                    <p className="text-sm text-gray-300 font-medium">{exp.role}</p>
                                </div>
                            </div>
                            <div>
                                <p className="text-sm text-gray-400 mb-1">{exp.duration}</p>
                                <p className="text-sm text-gray-500 mb-4">{exp.location}</p>
                            </div>
                        </div>




                        <ul className="list-disc list-inside text-gray-300 text-sm space-y-2 pl-2 mb-4">
                            {exp.responsibilities.map((item, idx) => (
                                <li key={idx}>{item}</li>
                            ))}
                        </ul>

                        <div className="mt-2">
                            <span className="text-sm font-semibold text-gray-300">Tech Stack:</span>
                            <div className="flex flex-wrap gap-2 mt-2">
                                {exp.techStack.map((tech, i) => (
                                    <span
                                        key={i}
                                        className="text-xs bg-indigo-100 text-indigo-800 font-medium px-2 py-1 rounded-full"
                                    >
                                        {tech}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export default ExperienceSection;
